import { useMemo } from 'react'
import { useIntl } from 'react-intl'
import { observer } from 'mobx-react'

import {
  getDashboardButton,
  getDashboardHeader,
  getDashboardSubtitle,
} from 'Modules/dashboard/utils/dashboard.utils'

import { Banner } from 'Components/_theme'

import { useStore } from 'Stores/index'

import { isActiveLanguage } from 'Utilities'

import { SupportedLanguagesEnum } from 'Constants/locale'

import type { DashboardOrganisationBannerProps } from './DashboardOrganisationBanner.types'

export const DashboardOrganisationBanner = observer(
  (props: DashboardOrganisationBannerProps) => {
    const { onNewOrderButtonClick, version, showNewOrderButton } = props

    const { portalContentStore } = useStore()
    const { portalContent } = portalContentStore

    const intl = useIntl()

    const isGermanLanguageActive = isActiveLanguage(SupportedLanguagesEnum.DE)

    const renderRentalHeader = useMemo(() => {
      return getDashboardHeader(
        intl,
        isGermanLanguageActive,
        portalContent,
        'OrganisationDashboard_title',
      )
    }, [intl, portalContent, isGermanLanguageActive])

    const renderRentalSubtitle = useMemo(() => {
      return getDashboardSubtitle(
        intl,
        isGermanLanguageActive,
        portalContent,
        'OrganisationDashboard_title_content',
      )
    }, [intl, portalContent, isGermanLanguageActive])

    const renderRentalButton = useMemo(() => {
      return getDashboardButton(
        intl,
        isGermanLanguageActive,
        portalContent,
        'OrganisationDashboard_button',
      )
    }, [isGermanLanguageActive, portalContent, intl])

    return (
      <Banner
        alt={
          portalContent?.dashboardImageURL
            ? undefined
            : intl.formatMessage({ id: 'Img_alt_dashboard_banner' })
        }
        buttonText={renderRentalButton}
        className="mb-6"
        imageSource={
          portalContent?.dashboardImageURL
            ? portalContent.dashboardImageURL
            : 'https://assets.everphone.app/portal-assets/dashboard/everphonedashboardsplashnew.png'
        }
        onButtonClick={onNewOrderButtonClick}
        showButton={showNewOrderButton}
        text={renderRentalSubtitle}
        title={renderRentalHeader}
        version={version}
      />
    )
  },
)
